import styled from 'styled-components';
import {
  spacing,
  colors,
  caption,
  heading4,
  subtitle2,
  body2,
  link,
  fontSizes,
  letterSpacing,
  fontWeights,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { FullWidth } from 'ui/utility/fullWidth';
import { SecondaryButton } from 'ui/button';

import type { NamePanelProps } from '../types';

export const Container = styled(FullWidth)`
  justify-content: center;
  background-color: ${colors.grey1};
  padding: ${spacing.x3} ${pxToRem(40)};
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(320)} 1fr;
  max-width: ${pxToRem(1216)};
  row-gap: ${spacing.base};
  margin: 0 auto;
  @media screen and (max-width: 1216) {
    column-gap: ${spacing.double};
    grid-template-columns: 1fr;
  }
`;

export const Layout = styled(FullWidth)`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  gap: ${spacing.double};
  padding: ${spacing.x3} ${pxToRem(40)};
  background-color: ${colors.grey1};
`;

export const Header = styled.h4`
  ${heading4};
`;

export const Hint = styled.span`
  ${caption};
  color: ${colors.textSecondary};
`;

export const Detail = styled.div`
  flex-grow: 1;
`;

export const Hr = styled.div`
  height: 1px;
  background: ${colors.grey15};
  margin: ${spacing.x3} ${spacing.base};
`;

export const Link = styled.a`
  ${link}
  font-size: ${fontSizes.s12};
  font-weight: ${fontWeights.regular};
  line-height: ${fontSizes.s16};
  letter-spacing: ${letterSpacing.pos10};
`;

export const Content = styled.div`
  display: flex;
  width: ${pxToRem(870)};
  background-color: ${colors.white};
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.double};
  padding-bottom: ${spacing.base};
`;

export const NamePanel = styled(Content)<NamePanelProps>`
  padding-top: ${(props) => (props.isEditing ? pxToRem(56) : spacing.double)};
`;

export const DetailHeader = styled.p`
  font-weight: bold;
  ${subtitle2};
`;

export const DetailBody = styled.p`
  ${body2};
  padding-bottom: ${spacing.base};
  color: ${colors.grey60};
`;

export const EditButton = SecondaryButton;
